// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JZ4c","importantInfo":"styles_importantInfo__3xifj"};